<script setup lang="ts">
import type { BlockCardsFragment } from '#graphql-operations'

interface BlockCardsProps {
  data: BlockCardsFragment
}

defineProps<BlockCardsProps>()
</script>

<template>
  <Section class="blockCards" padded>
    <div class="container">
      <div class="gap-12 lay-v lg:gap-1.75 lg:lay-h">
        <CardLauncher v-for="card in data.cards" :key="card!.id" :data="card!" />
      </div>
    </div>
  </Section>
</template>
